import React from "react";
import { Navigate } from "react-router-dom";

export default function FalseRoute() {
  return <Navigate to="/" replace />;
}
